const planingTimeline = () => {
    const time = document.querySelectorAll('.gs-timeline');


    if (time.length !== 0) {

        time.forEach(element => {

            const elStart = element.querySelector('.time__start');
            const elEnd = element.querySelector('.time__end');
            const currentDateEl = element.querySelector('.currentTimeline');
            const dates = element.querySelectorAll('.time');

            // date de début  :
            let startDate = elStart.getAttribute('date-start');
            startDate = new Date(startDate);

            // date de fin  :
            let endDate = elEnd.getAttribute('date-start');
            endDate = new Date(endDate);

            // date actuel :
            let currentDate = new Date();
        
            // Temps total de la timeline : 
            let totalElapsedTime = endDate.getTime() - startDate.getTime();

             // calcul de la taille d'un segment : 
            const allSize = (element.offsetWidth) - elEnd.clientWidth;
            const segmentSize = allSize / totalElapsedTime;

     
            // Temps écoulé : temps écoulé entre date de début et la date actuel 
            let elapsedTime = currentDate.getTime() - startDate.getTime();
            currentDateEl.style.width = (elapsedTime * segmentSize) + 'px';
           

            // calcul de la taille des étapes du projets 
           
            for (let i = 0; i < dates.length; i++) {

                let start = dates[i].getAttribute("date-start");
                start = new Date(start);

                // si on est pas à la fin du tableau
                if ((i + 1) < dates.length) {
                    let end = dates[i + 1].getAttribute("date-start");
                    end = new Date(end);

                    // temps écoulé;
                    let elapsedTime = end.getTime() - start.getTime();
                    const sizeSegment = elapsedTime * segmentSize;
                    dates[i].style.width = sizeSegment + 'px';
                }
            };

        });
    }
}

export default planingTimeline;
